import React from 'react';
import { useNavigate } from 'react-router-dom';

const stories = [
  {
    name: 'Mick',
    title: 'Meet Mick: Computer Information Systems Expert',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&h=600&fit=crop&crop=face',
  },
  {
    name: 'Michael',
    title: 'Meet Michael: Corporate Attorney',
    image: 'https://images.pexels.com/photos/30004315/pexels-photo-30004315.jpeg?auto=compress&cs=tinysrgb&w=600&h=600&fit=crop',
  },
  {
    name: 'Natasha',
    title: 'Meet Natasha: Finance Leader',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=600&h=600&fit=crop&crop=face',
  },
];

const PlayIcon = () => (
  <div className="absolute right-3 top-3 grid place-items-center rounded-full bg-black/50 p-2 opacity-0 duration-300 group-hover:opacity-100">
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 16 16"
      className="text-white"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393" />
    </svg>
  </div>
);

const APEXSection = () => {
  const navigate = useNavigate();

  return (
    <div className="relative mt-20">
      <div className="gap-6 space-y-16 lg:grid lg:grid-cols-4 lg:space-y-0">
        {/* Left: APEX Card (3 cols) */}
        <div
          className="group top-8 h-fit cursor-pointer duration-200 lg:sticky lg:col-span-3"
          style={{ top: '8px' }}
          onClick={() => navigate('/about')}
        >
          {/* Gradient banner */}
          <div className="relative aspect-square w-full overflow-hidden rounded-lg sm:aspect-video">
            <div className="grid h-full w-full scale-[1.02] cursor-pointer place-items-center duration-300 group-hover:scale-[1.1]">
              <div className="apex-animated-gradient" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 top-0 z-10 flex items-center justify-center font-medium duration-300 group-hover:scale-[1.02]">
              <p className="flex flex-row items-center gap-2 text-6xl font-thin tracking-wide text-white sm:text-8xl max-sm:text-light">
                APEX
              </p>
            </div>
          </div>

          {/* Title below APEX */}
          <div className="mt-4 text-3xl sm:mt-6 sm:text-5xl">The AI Productivity Index</div>
          <div className="mt-4 flex flex-row items-center gap-3 text-sm sm:mt-6">
            <div>Release</div>
            <div className="text-gray-500">5 min read</div>
          </div>
        </div>

        {/* Right: Stories Column (1 col) */}
        <div className="col-span-1 flex flex-col items-start justify-between pb-11 gap-12 max-sm:space-y-12 sm:flex sm:gap-4 md:flex-row lg:flex-col lg:gap-12">
          {stories.map((story, idx) => (
            <button
              key={idx}
              className="group w-full text-left"
              onClick={() => navigate('/stories')}
            >
              <div className="relative aspect-square w-full overflow-hidden rounded-[8px] bg-gray-50">
                <img
                  alt={`${story.name} - ${story.title}`}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover object-top duration-300 hover:scale-[1.02]"
                  src={story.image}
                />
                <PlayIcon />
              </div>
              <div className="mt-4 text-lg">{story.title}</div>
              <div className="mt-2 flex flex-row items-center gap-3 text-sm">
                <div>{story.name}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default APEXSection;
